// LIBRERIE
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";


const Presentation: React.FC = () => {
    const { t } = useTranslation();

    return(
        <section id="presentation" className="text-center space-ptb">
            <div className="container">
                <div className="row">
                    <div className="col-12 col-xl-9 offset-xl-3 text-right">
                        <h1 className="mb-4">{t('homePage.presentation.presentationTitle')}</h1>
                        <p dangerouslySetInnerHTML={{ __html: t('homePage.presentation.text1') as string }}></p>
                        <p dangerouslySetInnerHTML={{ __html: t('homePage.presentation.text2') as string }}></p>
                        <Link to={'/chi-siamo'} className="btn btn-primary text-uppercase">
                            <span>{t('homePage.presentation.btnText')}</span>    
                        </Link>
                    </div>
                </div>
            </div>
            <img src={''} className="d-none d-xl-block" alt="Alessandro Salvadori"/>
        </section>
    )
}
export default Presentation;